import { render, staticRenderFns } from "./hottest-block.vue?vue&type=template&id=748b309a&scoped=true&"
import script from "./hottest-block.vue?vue&type=script&lang=js&"
export * from "./hottest-block.vue?vue&type=script&lang=js&"
import style0 from "./hottest-block.vue?vue&type=style&index=0&id=748b309a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b309a",
  null
  
)

export default component.exports